import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useUseClientServiceMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: { location_id: number; specialist_id?: number };
    }) =>
      HttpClient.request<MutationResponse>({
        method: 'PUT',
        url: params.url,
        data: params.data,
      }),
  });
